import React, {useState} from 'react';
import {NavLink} from "react-router-dom";
import Status from "../../../pages/parcels/form_v3/status";
import CopyString from "../../../pages/parcels/form_v3/copyString";
import MapModal from "../../../pages/parcels/form_v3/mapModal";
import Logos from "../../../pages/parcels/form_v3/logos";
import Info from "../../Info";
import {costFormat} from "../../../services/cost";
import moment from "moment";
import {buildParcelExternalTrackingUrl} from "../../../services/trackingLink";

// Вспомогательная функция для определения параметра cameFrom
const getCameFrom = () => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/reports')) {
        return 'reports';
    } else if (currentPath.includes('/parcels/list')) {
        return 'parcels';
    }
    return 'parcels'; // по умолчанию
};

// Вспомогательная функция для формирования URL посылки
const getParcelUrl = (parcelId) => {
    const cameFrom = getCameFrom();
    return `/parcels/${parcelId}/new?cameFrom=${cameFrom}`;
};

const TableCellValue = ({column, row}) => {
    const [maps, setMaps] = useState({open: false});


    const cellType = (col) => {
        switch (col.type) {
            case 'numberAndState':
                return <div className='cell-value__number-status'>
                    {row.number && <div>
                        № <NavLink 
                            style={{marginLeft: '5px', color: '#459EFF'}} 
                            className='total__change-btn_name'
                            to={getParcelUrl(row.id)}
                        >{row.number}</NavLink>
                    </div>}
                    <div>
                        {row.status && <Status
                            name={row.status}
                            code={row.statusCode}
                        />}
                    </div>
                </div>;
            case 'id':
            case 'parcelId':
                // Для отчетов - "Идентификатор посылки"
                return <div>
                    {row.id && <NavLink 
                        style={{color: '#459EFF'}} 
                        className='total__change-btn_name'
                        to={getParcelUrl(row.id)}
                    >{row.id}</NavLink>}
                </div>;
            case 'externalNumber':
                return <div>
                    <div>
                        <b>{row.parcelType}</b>
                    </div>
                    {row.externalNumber && <div>
                        № <CopyString onClick={row.parcelUrl ? () => window.open(buildParcelExternalTrackingUrl(row.parcelUrl, row.externalNumber), '_blank') : true}>{row.externalNumber}</CopyString>
                    </div>}
                    {row.weight !== null && <div>
                        Расч/вес: <span className='c_black'>{row.weight} кг.</span>
                    </div>}
                    {row.actualWeight !== null && <div>
                        Факт/вес: <b className={row.actualWeight !== row.weight ? 'c_blue' : 'c_black'}>{row.actualWeight} кг.</b>
                    </div>}
                </div>;
            case 'btns':
                return <div className='cell-value__btns'>
                    {col.btns && col.btns.map((btn, idx) => React.cloneElement(btn(row), { key: idx }))}
                </div>;
            case 'departureDate':
            case 'deliveryDate':
                const actualDate = row[`actual${col.type.charAt(0).toUpperCase() + col.type.slice(1)}`];
                return <div className='cell-value__dates'>
                    {row[col.type] && <div>
                        <div
                            className='c_black'>{row[col.type] ? moment(row[col.type]).format('DD.MM.YYYY') : null}</div>
                        (Плановая дата)
                    </div>}
                    {actualDate && <div>
                        <div
                            className='c_black'>{actualDate ? moment(actualDate).format('DD.MM.YYYY') : '-'}</div>
                        (Фактическая дата)
                    </div>}
                </div>;
            case 'lastIssueDeadline':
                return (
                    <div className='cell-value__dates'>
                        <div className='c_black'>{row[col.type] ? moment(row[col.type]).format('DD.MM.YYYY hh:mm') : null}</div>
                    </div>
                );
            case 'cost':
                return <div className='cell-value__cost'>
                    {!isNaN(row.deliveryCost) && <div>
                        Расч/ст: <span className='c_black cost'>{costFormat(row.deliveryCost)} ₽</span>
                    </div>}
                    {row.actualDeliveryCost && !isNaN(row.actualDeliveryCost) && <div>
                        Факт/ст: <b className={`${row.actualDeliveryCost !== row.deliveryCost ? 'c_blue' : 'c_black'} cost`}>{costFormat(row.actualDeliveryCost)} ₽</b>
                    </div>}
                </div>;
            case 'shipmentCompany':
                return <div className='shipment-company'>
                    {row.carrier && <Info
                        name={row.carrier}
                        label={row.carrierServiceName}
                        text={row.carrierServiceDescription}
                        position={'right'}
                        offset={[7]}
                    />}
                    <Logos
                        name={row.carrierCode}
                    />
                </div>;
            case 'issueStatus':
                return <div>{row.issueStatus && row.issueStatus.label}</div>;
            case 'shipment':
            case 'delivery':
                return <div>
                    <div>
                        <CopyString
                            text={row[`${col.type}Address`]}
                            onClick={() => {
                                setMaps({
                                        open: true,
                                        address: row[`${col.type}Address`],
                                        coordinates: [row[`${col.type}Lat`], row[`${col.type}Lon`]]
                                    })
                            }}
                        >
                            {row[`${col.type}City`]}
                        </CopyString>
                    </div>
                    <div>
                        {row[`${col.type === 'shipment' ? 'sender' : 'recipient'}CompanyName`]}
                    </div>
                    <div>
                        {row[`${col.type === 'shipment' ? 'sender' : 'recipient'}Name`]}
                    </div>
                    <MapModal
                        open={maps.open}
                        onClose={() => setMaps({open: false})}
                        address={maps.address}
                        coordinates={maps.coordinates}
                    />
                </div>;
            default:
                // Проверяем, является ли это колонкой с ID накладной
                if (col.fieldName === 'id' || col.fieldName === 'parcelId' || col.fieldName === 'number') {
                    const parcelId = row[col.fieldName];
                    if (parcelId) {
                        return <NavLink 
                            style={{color: '#459EFF'}} 
                            className='total__change-btn_name'
                            to={getParcelUrl(parcelId)}
                        >{parcelId}</NavLink>;
                    }
                }
                return row[col.fieldName] || '';
        }
    }
    return (
        cellType(column)
    );
};

export default TableCellValue;


// WEBPACK FOOTER //
// ./App/components/Table/components/TableCellValue.jsx